const ROOT = 'ROUTER'

export const CHANGE_ROUTE = `${ROOT}/CHANGE_ROUTE`

export const changeRoute = payload => ({
  type: CHANGE_ROUTE,
  payload,
})
